import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-threeDotsVertical",
  "use": "icon-threeDotsVertical-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-threeDotsVertical\"><defs><style type=\"text/css\"></style></defs><path d=\"M393.846154 866.461538c0-64.984615 53.169231-118.153846 118.153846-118.153846s118.153846 53.169231 118.153846 118.153846-53.169231 118.153846-118.153846 118.153847-118.153846-53.169231-118.153846-118.153847z m0-354.461538c0-64.984615 53.169231-118.153846 118.153846-118.153846s118.153846 53.169231 118.153846 118.153846-53.169231 118.153846-118.153846 118.153846-118.153846-53.169231-118.153846-118.153846z m0-354.461538c0-64.984615 53.169231-118.153846 118.153846-118.153847s118.153846 53.169231 118.153846 118.153847-53.169231 118.153846-118.153846 118.153846-118.153846-53.169231-118.153846-118.153846z\" p-id=\"1872\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/threeDotsVertical.svg
// module id = XPYq
// module chunks = 25